const check = require('check-types');
const pick = require('lodash.pick');
module.exports = function () {
  let values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let pickDefinitions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return check.nonEmptyArray(pickDefinitions) ? pick(values, pickDefinitions) : values;
};